import React, { useState, useEffect, useRef } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
// import Lottie from 'lottie-react';
// import loadingSpinner from '../../../assets/loading_spinner.json';  // Adjust path as needed
import './SignIn.css';
import { useContext } from 'react';
import { TestStatusContext } from '../../../App';  // Adjust path as needed

const SignIn = ({ onLogin }) => {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notificationSent = useRef(false);
  const { testStatus, setTestStatus } = useContext(TestStatusContext);

  const handleSignIn = async (signInData) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        'https://9vcop53tl6.execute-api.us-east-2.amazonaws.com/Production/sign-in-get-quoll-user',
        signInData
      );

      if (response.data.status === 'pass') {
        console.log(response.data);
        const userData = {
          user_id: response.data.user_id,
          industry: response.data.industry,
          company: response.data.company,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          email: signInData.email,
          marketing_content: response.data.marketing_content,
          marketing_offers: response.data.marketing_offers,
          marketing_product: response.data.marketing_product,
          timestamp: new Date().toISOString(),
          purchased_addresses: response.data.purchased_addresses
        };
        onLogin(userData);
      } else {
        setIsLoading(false);
        switch (response.data.fail_code) {
          // Reason: missing_required_fields
          case 1:
          case 5:
            setError("Hmmm, looks like our system is missing some information. Please try again.");
            break;
          // Reason: user_not_found
          case 2: 
            setError("No user exists with this email. Please sign up first.");
            break;
          // Reason: invalid_password
          case 3:
            setError("Password is incorrect. Please try again.");
            break;
          // Reason: invalid_password
          case 4: 
            setError(signInData.signin_method === 'sso'
              ? 'It looks like you signed up with email and password. Please try signing in with your email and password.'
              : 'It looks like you signed up with Google. Please try signing in with Google.');
            break;
          
          // case 5:
          //   setError("Your account is not verified. Please check your email for a verification link.");
          //   break;
          // case 'no_user':
          //   setError('No user exists with this email. Please sign up first.');
          //   break;
          default:
            setError(`An error occurred. Please try again. ${response.data.reason}`);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Sign-in error:', error);
      setError('An error occurred. Please try again.');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const signInData = {
      email,
      password,
      sign_in_method: 'email'
    };
    await handleSignIn(signInData);
  };

  // useEffect(() => {
  //   const autoSignIn = async () => {
  //     try {
  //       const searchParams = new URLSearchParams(window.location.search);
  //       const testLogin = searchParams.get('test_login');
  //       const tester = searchParams.get('tester');
        
  //       if (testLogin && tester) {
  //         const signInData = {
  //           email: 'testaccount@quollintelligence.com',
  //           password: 'test123',
  //           signin_method: 'form'
  //         };
          
  //         // Set test status
  //         setTestStatus(true);  // Set test status
          
  //         await handleSignIn(signInData);
          
  //         // After successful sign-in send notification
  //         if (!notificationSent.current) {
  //           await axios.post(`${import.meta.env.VITE_API_BASE_URL}/site-tracker`, {
  //             testLogin: true,
  //             tester: tester
  //           });
  //           notificationSent.current = true;
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Auto sign-in failed:', error);
  //       setError('Automatic sign-in failed. Please try manually.');
  //     }
  //   };

  //   // Only run once on mount
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const testLogin = searchParams.get('test_login');
  //   const tester = searchParams.get('tester');
  //   if (testLogin && tester) {
  //     autoSignIn();
  //   }
  // }, []); // Empty dependency array

  const handleGoogleSuccess = async (credentialResponse) => {
    const decodedToken = jwtDecode(credentialResponse.credential);
    const signInData = {
      email: decodedToken.email,
      password: null,
      sign_in_method: 'sso'
    };
    await handleSignIn(signInData);
  };


  return (
    <>
      <div className="auth-content">
        {/* <h1 className="auth-header">Sign In</h1> */}
        {error && <p className="error-message">{error}</p>}
        {!showEmailForm ? (
          <div className="auth-options">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => setError('Google Sign-In failed. Please try again.')}
              useOneTap
              type="standard"
              theme="filled_blue"
              size="large"
              text="signin_with"
              shape="pill"
              logo_alignment="left"
            />
            <div className="or-divider">
              <span>or</span>
            </div>
            <div className="button-group">
              <button onClick={() => setShowEmailForm(true)} className="email-signin-button">
                Use Email Address
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleFormSubmit}>
            <div className="horizontal-inputs">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                required
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
            </div>
            <div className="button-group">
              <button type="button" onClick={() => setShowEmailForm(false)} className="back-button">
                Back
              </button>
              <button className='auth-button-submit' type="submit">Sign In</button>
            </div>
          </form>
        )}
      </div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-box">
            <div className="loading-animation-dots-bars" />
            {/* <Lottie 
              animationData={loadingSpinner}
              loop={true} 
              style={{ width: 100, height: 100 }} 
            /> */}
            <p>Fetching Your Account!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default SignIn;
